import React, {useEffect, useLayoutEffect, useCallback, useRef} from 'react'
import useProfileStore from '../store/profileStore';
import useDragLineStore from '../store/dragLineStore';
import * as THREE from 'three';

function DragLine() {
  const dragMode = useDragLineStore(state => state.dragMode);
  const selectedPts = useProfileStore(state => state.selectedPts)
  const dragLineRef = useRef();

  const moveLine = (currentPt) => {
    console.log('moveline created')
    const l2 = selectedPts.length
    if (dragMode && selectedPts.length){
          dragLineRef.current.visible = true;
          dragLineRef.current.geometry.attributes.position.setXYZ(0,selectedPts[l2-1][0], selectedPts[l2-1][1], selectedPts[l2-1][2]);
          dragLineRef.current.geometry.attributes.position.setXYZ(1,currentPt[0],currentPt[1],currentPt[2]);
          dragLineRef.current.geometry.attributes.position.needsUpdate = true;
          dragLineRef.current.geometry.computeBoundingSphere()
    }
  }

  useEffect(() => {
    if (dragMode && selectedPts.length) {
      dragLineRef.current.geometry.setFromPoints([selectedPts[selectedPts.length-1], selectedPts[selectedPts.length-1]].map((point) => new THREE.Vector3(...point)))}
      console.log('drag line created')
    }
  , [dragMode, selectedPts])

  useEffect(() => {
    useDragLineStore.subscribe(moveLine, state => state.currentPt);
  })


  return (
    <>
      {(dragMode && selectedPts.length) &&
        <line ref={dragLineRef}>
          <bufferGeometry/>
          <lineBasicMaterial attach="material" color="red" />
        </line>
      }
    </>
  )
}

export default DragLine
